module.exports = __webpack_public_path__ + "static/img/诊疗风控@2x2.5c1f430b.png";